import React from 'react';
import Cibercontent from '../components/Cibercontent';
import Footer from '../components/footer';


const Ciberpage = () => {
  return (
    <div className="Ciberseg">
        
          <Cibercontent />
          <Footer />
    </div>
  );
}

export default Ciberpage;